import { render } from "./ShopFooterData.vue?vue&type=template&id=4c3f0a74&ts=true"
import script from "./ShopFooterData.vue?vue&type=script&lang=ts"
export * from "./ShopFooterData.vue?vue&type=script&lang=ts"

import "./ShopFooterData.vue?vue&type=style&index=0&id=4c3f0a74&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__